import { InvoiceBase } from '../../invoicing/abstract/invoice-base.model';
import { PurchaseInvoiceAllocation } from './purchase-invoice-allocation.model';
import { PurchaseInvoiceItem } from './purchase-invoice-item.model';
import { PurchaseInvoiceTax } from './purchase-invoice-tax.model';

export class PurchaseInvoice extends InvoiceBase {

    static override CLASS_NAME: string = 'PurchaseInvoice';

    private _allocations!: PurchaseInvoiceAllocation[];
    private _items!: PurchaseInvoiceItem[];
    private _taxes!: PurchaseInvoiceTax[];

    constructor(data: any) {
        super(data);
        this._allocations = this._allocations || [];
        this._items = this._items || [];
        this._taxes = this._taxes || [];
    }

    public get allocations(): PurchaseInvoiceAllocation[] {
        return this._allocations;
    }

    public set allocations(value: any) {
        this._setValue('_allocations', value, 'PurchaseInvoiceAllocation');
    }

    /**
     * ⚠️ Une facture d'achat n'est **jamais** traitée comme un document interne, quelle
     * que soit son origine. Depuis #1020, les factures que Biifor dépose chez ses clients
     * portent `origin.code === 'internal'` (elles portaient `api` avant la reprise) : les
     * aligner sur `InvoiceBase.isInternal` les verrouillerait en lecture seule et leur
     * retirerait imputations, suppression et ventilation de taxe. Vues du client, ce sont
     * des factures reçues comme les autres — l'override est délibéré.
     */
    public override get isInternal(): boolean {
        return false;
    }

    public get items(): PurchaseInvoiceItem[] {
        return this._items;
    }

    public set items(value: any) {
        this._setValue('_items', value, 'PurchaseInvoiceItem');
    }

    public override get taxAmount(): number {
        return super.taxAmount;
    }

    public override set taxAmount(value: any) {
        super.taxAmount = value;
        if (this.loaded && value === 0) {
            this.taxes = [];
        }
    }

    public get taxes(): PurchaseInvoiceTax[] {
        return this._taxes;
    }

    public set taxes(value: any) {
        this._setValue('_taxes', value, 'PurchaseInvoiceTax');
    }
}
